import { IInvoice } from "../../../models/invoice";

export const invoiceTitleMapper = (row: IInvoice) => (
    <strong>{`${row.internalInvoiceNumber}`}</strong>
);
